import { Typography } from "@lyfegen-platform/react-common";
import { Box, Theme } from "@material-ui/core";
import { getPublicAgreementStatusIcon, publicAgreementStatusToColor } from "../utils/status";

interface PAStatusProps {
	props: any;
	palette: Theme["palette"];
	t: any;
}

const Text: React.FC<PAStatusProps> = ({ props, palette, t }) => (
	<Typography
		type="status"
		style={{
			marginLeft: "2px",
			color: publicAgreementStatusToColor(props?.status, palette, true),
		}}
	>
		{t(props?.status)}
	</Typography>
);

export default function PublicAgreementStatusComponent({ props, palette, t }: PAStatusProps) {
	const status = props.status;

	return (
		<Box
			display="flex"
			alignItems="center"
			style={{
				height: "22px",
				borderRadius: "100px",
				backgroundColor: publicAgreementStatusToColor(props?.status, palette),
				padding: "3px 8px 3px 6px",
				fontWeight: 600,
				maxWidth: "fit-content",
			}}
		>
			{status && getPublicAgreementStatusIcon(status)}
			<Text props={props} palette={palette} t={t} />
		</Box>
	);
}
